import store from '@/store';

export default class BroadcastWhatsAppListStartedEvent {
  constructor(body) {
    const agentId = store.state.attendance.Attendance.agentId;
    const broadcastWhatsAppId = body.id;
    if (
      body.event == 'BroadcastWhatsAppListStartedEvent' &&
      agentId == body.agentId
    ) {
      const broadcastInformation = {
        broadcastWhatsAppId,
        status: 'SENDING',
        type: 'default',
      };
      store.dispatch(
        'broadcast/updateBroadcastWhatsAppStatus',
        broadcastInformation,
      );
      console.log(
        '[AGENT/BROADCAST] - Broadcast ' +
          broadcastWhatsAppId +
          ' iniciando envio de mensagens.',
      );
    }
  }
}
